import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { API_KEY } from "../constants";

const secretKey = "your-secret-key";

export const setEncryptedCookie = (name, value, options) => {
  const encryptedValue = CryptoJS.AES.encrypt(value, secretKey).toString();
  Cookies.set(name, encryptedValue, options);
};

export const getDecryptedCookie = (name) => {
  const encryptedValue = Cookies.get(name);
  if (!encryptedValue) return null;

  const bytes = CryptoJS.AES.decrypt(encryptedValue, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const removeCookie = (name) => {
  Cookies.remove(name);
};

export const generateRandomIV = () => {
  let iv = "";
  const possibleChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < 16; i++) {
    iv += possibleChars.charAt(
      Math.floor(Math.random() * possibleChars.length)
    );
  }
  return iv;
};

export const encryptAES = (payload, key, iv) => {
  try {
    const stringPayload = JSON.stringify(payload);
    const iv = generateRandomIV();

    // const iv = generateRandomIV(); // Generate random IV
    const encrypted = CryptoJS.AES.encrypt(
      stringPayload,
      CryptoJS.enc.Utf8.parse(API_KEY.AES_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return {
      iv,
      encryptedData: encrypted.toString(),
    };
  } catch (error) {
    console.error("Error encrypting payload:", error);
    return null;
  }
};

export const decryptAES = (encryptedPayload, iv) => {
  try {
    const bytes = CryptoJS.AES.decrypt(
      encryptedPayload,
      CryptoJS.enc.Utf8.parse(API_KEY.AES_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error("Error decrypting payload:", error);
    return null;
  }
};
